import { useEffect, useMemo } from 'react'

import OfferMapContainer from '../OfferMap'
import { FLASH_OFFERS_TYPES } from 'constants/offerList'
import Heading from 'LuxKit/Typography/Heading'
import { useAppSelector } from 'hooks/reduxHooks'
import useOfferList from 'hooks/Offers/useOfferList'
import { fetchOffersById } from 'actions/OfferActions'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { rem } from 'polished'
import styled from 'styled-components'

const Block = styled(VerticalSpacer)`
  margin-top: ${rem(40)};
`

interface Props {
  filters: App.OfferListFilters
  markers: Array<App.MapMarker>
  title: string
  hash: string
  key: string
  withMap: boolean
}

function DiscoverGuideMap(props: Props) {
  const offerList = useOfferList({
    ...props.filters,
    offerTypes: FLASH_OFFERS_TYPES,
  })

  const offerState = useAppSelector(state => state.offer.offers)

  useEffect(() => {
    fetchOffersById(offerList.offerIds)
  }, [offerList.offerIds])
  const offers = useMemo(() => {
    return offerList.offerIds.map(id => offerState[id]).filter(Boolean)
  }, [offerList.offerIds, offerState])

  if (offerList.fetching || offerList.offerIds.length === 0) {
    return null
  }

  return <Block gap={40} id={props.hash}>
    <Heading variant="heading3" as="h2" align="center">{props.title}</Heading>
    {props.withMap && <OfferMapContainer
      filters={props.filters}
      markers={props.markers}
      offers={offers}
      loaded={!offerList.fetching}
    />}
  </Block>
}

export default DiscoverGuideMap
